export default __webpack_public_path__ + "static/media/hht2_ep16_timeline_q04_b.9425ebee.png";